import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getDeviceState, selectDeviceState, selectDeviceStateError, resetDeviceStateRetryCount, setDeviceStateError } from '../../deviceState/deviceStateSlice';
import Signal from '../../deviceState/Signal';
import { isDriverSignal, isPrioritySignal } from '../../deviceState/SignalGroup';

import styles from './TrafficLightHUD.module.css';

const TrafficLightHUD = ({ activeLight, distance }) => {
    const dispatch = useDispatch();
    const deviceState = useSelector(selectDeviceState);
    const error = useSelector(selectDeviceStateError);
    const { t } = useTranslation();

    // Polling logic
    useEffect(() => {
        if (!activeLight) return;
        const deviceId = activeLight.liva_nro;

        // Reset state for new light
        dispatch(setDeviceStateError(null));
        dispatch(resetDeviceStateRetryCount());

        const fetchState = () => dispatch(getDeviceState(deviceId));
        fetchState(); // Initial fetch

        const interval = setInterval(fetchState, 1000);
        return () => clearInterval(interval);
    }, [activeLight, dispatch]);

    if (!activeLight) return null;

    const allSignals = deviceState?.signalGroup || [];
    const vehicleSignals = allSignals.filter(s => isDriverSignal(s) && !isPrioritySignal(s));
    const prioritySignals = allSignals.filter(s => isPrioritySignal(s));

    return (
        <div className={styles.TrafficLightHUD}>
            <h3 className={styles.Title}>{activeLight.paikka}</h3>
            <div className={styles.Distance}>
                {Math.round(distance)} m
            </div>

            {error ? (
                <div className={styles.Error}>{t('hud.connection_error') || 'Connection Error'}</div>
            ) : (
                <div className={styles.SignalsContainer}>
                    {/* Vehicle Signals Row */}
                    <div className={styles.SignalsRow}>
                        {vehicleSignals.length > 0 ? (
                            vehicleSignals.map(signal => (
                                <Signal key={signal.idx} signal={signal} />
                            ))
                        ) : (
                            <div className={styles.Loading}>{t('hud.loading') || 'Loading signals...'}</div>
                        )}
                    </div>

                    {/* Priority Signals Row */}
                    {prioritySignals.length > 0 && (
                        <div className={styles.PriorityRow}>
                            {prioritySignals.map(signal => (
                                <Signal key={signal.idx} signal={signal} />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TrafficLightHUD;
